import type { AdminUser } from "@features/users/api";

export const getPrimaryContact = (user: AdminUser | null | undefined, type: string) => {
  const contacts = user?.contacts ?? [];
  const prioritized = contacts.find((contact) => contact.type === type && contact.is_primary);
  if (prioritized) {
    return prioritized.value;
  }
  const fallback = contacts.find((contact) => contact.type === type);
  return fallback ? fallback.value : undefined;
};
